/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'
import type * as AppBskyEmbedRecord from './record.js'
import type * as AppBskyEmbedImages from './images.js'
import type * as AppBskyEmbedVideo from './video.js'
import type * as AppBskyEmbedGallery from './gallery.js'
import type * as AppBskyEmbedExternal from './external.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'app.bsky.embed.recordWithMedia'

export interface Main {
  $type?: 'app.bsky.embed.recordWithMedia'
  record: AppBskyEmbedRecord.Main
  media:
    | $Typed<AppBskyEmbedImages.Main>
    | $Typed<AppBskyEmbedVideo.Main>
    | $Typed<AppBskyEmbedGallery.Main>
    | $Typed<AppBskyEmbedExternal.Main>
    | { $type: string }
}

const hashMain = 'main'

export function isMain<V>(v: V) {
  return is$typed(v, id, hashMain)
}

export function validateMain<V>(v: V) {
  return validate<Main & V>(v, id, hashMain)
}

export interface View {
  $type?: 'app.bsky.embed.recordWithMedia#view'
  record: AppBskyEmbedRecord.View
  media:
    | $Typed<AppBskyEmbedImages.View>
    | $Typed<AppBskyEmbedVideo.View>
    | $Typed<AppBskyEmbedGallery.View>
    | $Typed<AppBskyEmbedExternal.View>
    | { $type: string }
}

const hashView = 'view'

export function isView<V>(v: V) {
  return is$typed(v, id, hashView)
}

export function validateView<V>(v: V) {
  return validate<View & V>(v, id, hashView)
}
